import { TComparePageType } from '../../types/comparePageType';
import { IApplicationState } from '../../types/redux';

export const selectComparePageType = (state: IApplicationState): TComparePageType => {
  return state.page.comparePageType;
};
